var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-container"},[_c('div',{staticClass:"pbg",style:({ backgroundImage: 'url(' + _vm.bgImage + ')' })}),_vm._v(" "),_c('div',{staticClass:"se-hero__overlay"},[_c('div',{staticClass:"l-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-16 col-xs-offset-1"},[_vm._t("default")],2)])])])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ef5d75c","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HomeSection.vue
// module id = null
// module chunks = 